import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PlayIcon from "../../assets/images/icons/play.png";

export default function CasinoCard({
  data,
  imageUrlCheck = false,
  imgHeight,
  index = 0,
  redirectUrl = null,
  customImageText = "",
  isLastElement = false,
  lastElementUrl = "",
  setShowAuthModals,
}) {
  const navigate = useNavigate();

  const { isAuth } = useSelector((state) => state.auth);

  const getredirectionURL = (data) => {
    if (isLastElement && lastElementUrl && isAuth) {
      navigate(lastElementUrl);
      return;
    }
    if (redirectUrl) {
      window.location.href = redirectUrl;
      return;
    }

    if (isAuth) {
      const redirectUrl = data?.href || data?.redirectUrl || data?.cover || "#";
      window.location.href = redirectUrl;
    } else {
      if (setShowAuthModals) {
        setShowAuthModals(true);
      }

      // navigate("#");
    }
  };
  const getImageUrl = (url) => {
    if (imageUrlCheck && url) {
      return url?.slice(1, url.length) || url;
    }
    return url || "";
  };

  return (
    <a
      onClick={() => getredirectionURL(data)}
      className="casino_games"
      key={`${data?.GameName || data?.name}_${index}`}
    >
      <div className="shadow position-relative">
        <img
          src={getImageUrl(data?.cover?.src || data?.imgUrl)}
          alt={data?.cover?.alt || ""}
          height={imgHeight}
        />

        <div className="overlayslideright">
          <div className="textslideright">
            <img src={PlayIcon} alt="PlayBtn" />
          </div>
        </div>
      </div>
      <span>{isLastElement ? customImageText : null}</span>
      <p>{data?.GameName || data?.name}</p>
    </a>
  );
}
